import { createAction, props } from '@ngrx/store';
import { InterviewsListFeatureState, InterviewsListGridData } from './interviews-list.models';

const snapshotPersisted = createAction(
  '[Interviews List] Snapshot persisted',
  props<{ snapshot: Omit<InterviewsListFeatureState, 'gridData'> }>()
);

const gridDataCached = createAction(
  '[Interviews List] Grid data cached',
  props<{ gridData: InterviewsListGridData }>()
);

const gridDataCleared = createAction('[Interviews List] Grid data cleared');

const cleared = createAction('[Interviews List] Cleared');

export const InterviewsListActions = {
  snapshotPersisted,
  gridDataCached,
  gridDataCleared,
  cleared
};
